import asyncComponent from '../../components/AsyncComponent';

const PartnerView = asyncComponent(() => import('../../containers/Partners/View'));

export default PartnerView;
